<div class="banner d-lg-block d-none">
  <div class="container banner-container h-100 d-flex flex-row align-items-center justify-content-between">
    <div class="banner-details d-flex flex-column justify-content-start">
      <a routerLink="/account" class="d-flex flex-row align-items-center justify-content-start">
        <h1 class="account-name text-white">{{ 'home.page.title' | translate }} {{ (memberData$ | async)?.name }}</h1>
        <span class="material-symbols-outlined text-white"> chevron_right </span>
      </a>

      <p class="account-id font-size-14 text-white text-start text-uppercase">
        {{ 'banner.details.id' | translate }} {{ (memberData$ | async)?.memberId }}
      </p>
    </div>
    <img class="banner-logo" src="assets/images/banner-logo.png" alt="banner-logo" />
  </div>
</div>
